import { FinnairCart } from '@fcom/dapi/api/models/finnair-cart';
import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { isFlight } from '@fcom/common-booking/utils/common-booking.utils';

export const mapFlightsFromCartData = (cd: FinnairCart): FinnairItineraryItemFlight[] =>
  cd?.bounds.reduce((all, b) => all.concat(...b.itinerary.filter(isFlight)), []) ?? [];
